var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconGenderFemale = function SvgIconGenderFemale(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ico"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.6434 7.40535C15.6434 4.23603 13.074 1.66666 9.90471 1.66666C6.73539 1.66666 4.16602 4.23603 4.16602 7.40535C4.16602 10.218 6.19086 12.5539 8.86131 13.0169V14.1597H7.29621C7.0081 14.1597 6.77451 14.3933 6.77451 14.6814V15.7248C6.77451 16.0129 7.0081 16.2465 7.29621 16.2465H8.86131V17.8116C8.86131 18.0997 9.0949 18.3333 9.38301 18.3333H10.4264C10.7146 18.3333 10.9481 18.0997 10.9481 17.8116V16.2465H12.5132C12.8014 16.2465 13.0349 16.0129 13.0349 15.7248V14.6814C13.0349 14.3933 12.8014 14.1597 12.5132 14.1597H10.9481V13.0169C13.6186 12.5539 15.6434 10.2193 15.6434 7.40535ZM9.90471 10.5355C8.17886 10.5355 6.77451 9.1312 6.77451 7.40535C6.77451 5.67918 8.17886 4.27515 9.90471 4.27515C11.6309 4.27515 13.0349 5.67918 13.0349 7.40535C13.0349 9.13022 11.6296 10.5355 9.90471 10.5355Z",
    fill: "#028BB7"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconGenderFemale, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-gender-female.68d01832.svg";
export { ForwardRef as ReactComponent };